export var ORDER;
(function (ORDER) {
    ORDER["ASC"] = "asc";
    ORDER["DESC"] = "desc";
})(ORDER || (ORDER = {}));
export var RESTRICTION;
(function (RESTRICTION) {
    RESTRICTION["FAVORITE"] = "favorite";
    RESTRICTION["SCREENSHOT"] = "screenshot";
})(RESTRICTION || (RESTRICTION = {}));
